import { SITE_ENGINEER_LISTING } from "./type";

const initalState = {
  siteEngineerList: {},
};

const siteEngineerListReducer = (state = initalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SITE_ENGINEER_LISTING:
      return {
        ...state,
        siteEngineerList: payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default siteEngineerListReducer;
